
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.74408 6.07709C3.06951 5.75165 3.59715 5.75165 3.92259 6.07709L10 12.1545L16.0774 6.07709C16.4028 5.75165 16.9305 5.75165 17.2559 6.07709C17.5814 6.40252 17.5814 6.93016 17.2559 7.2556L10.5893 13.9223C10.2638 14.2477 9.73618 14.2477 9.41074 13.9223L2.74408 7.2556C2.41864 6.93016 2.41864 6.40252 2.74408 6.07709Z","fill":"currentColor"}})])
          )
        }
      }
    